import { MONTHLY_EXPIRY_DATES_RECEIVED } from 'state/monthlyExpiryDates/monthlyExpiryDates.action';

import type { Action } from '../actions';
import type { BdrMonthlyExpiryDatesState } from './monthlyExpiryDates.model';
import { initialBdrMonthlyExpiryDatesState } from './monthlyExpiryDates.model';

export function monthlyExpiryDateCalendarsReducer(
  state: BdrMonthlyExpiryDatesState = initialBdrMonthlyExpiryDatesState,
  action: Action,
): BdrMonthlyExpiryDatesState {
  switch (action.type) {
    case MONTHLY_EXPIRY_DATES_RECEIVED:
      return { ...state, ...action.calendars };
    default:
      return state;
  }
}
